import { Component, OnInit } from '@angular/core';

import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  notificationType: string;
  notification: string;

  constructor(private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.notificationService.notificationType.subscribe((notificationType) => {
      if (notificationType) {
        this.notificationType = notificationType;
        switch (notificationType) {
          case 'error':
          this.notification = 'An error occurred.';
          if (!environment.production) {
            this.notification += ' Please check console for more details';
          } else {
            this.notification += ' Please log complete details on reproducing the error';
          }
          break;
        }
      }
    });
  }

  onClose() {
    this.notificationType = '';
  }

}
